
































import Vue from 'vue'
import axios from 'axios'
import Component from 'vue-class-component'
import ShippingForm from '../components/Shipping.vue'

@Component({
  components: {
    ShippingForm
  }
})
export default class ConfirmationPage extends Vue {
  data: any = null

  invalidPaymentType = false

  async mounted() {
    const result = await axios.get(`/payments/${this.$route.params.paymentId}`)
    this.data = {
      ...result.data,
      payeeGivenName: result.data.givenName,
      payeeSurname: result.data.surname,
      payeeEmail: result.data.email
    }

    if (this.data.type === 'certificate') {
      this.invalidPaymentType = true
    }
  }

  get paymentType() {
    switch (this.data.type) {
      case 'certificate':
        return 'E-Certificate'
      case 'hard-copies':
        return '2 x Hard Copies'
      case 'embossed':
        return 'Professional Embossed Copy'
    }
  }

  async confirmDetails(data: any) {
    const userDetails = {
      givenName: data.payeeGivenName,
      surname: data.payeeSurname,
      email: data.payeeEmail
    }

    const shippingDetails = {
      payeeAddress1: data.payeeAddress1,
      payeeAddress2: data.payeeAddress2,
      payeeCity: data.payeeCity,
      payeeState: data.payeeState,
      payeeCountry: data.payeeCountry,
      payeePostcode: data.payeePostcode
    }

    try {
      await axios.patch(`/users/${data.userId}`, userDetails)
      await axios.patch(`/payments/${this.$route.params.paymentId}`, shippingDetails)
      this.$store.dispatch('showSuccess', 'Details confirmed.')
      this.$router.push('/')
    } catch (error) {
      this.$store.dispatch('showError', 'Error confirming details')
    }
  }
}
